import React, { Component } from 'react';
import PropTypes from 'prop-types';
import APIManager from 'modules/common/apiManager';
import {
    DataWrapperClass,
    InsightWrapper
} from '../../styles';
import {
    WrapperData,
    Wrapper,
    ModalTrigger,
    Pagination,
    Button,
    FormControl,
    ActionButtons,
    Table,
    Label,
    Tip,
    DataWithLoader,
    FormGroup,
    ControlLabel,
    ReportPagination,
    SeachForm,
    BarItems,
    ManageColumns
} from 'modules/theme';
import Filter from './../../Filter';
import { modalType } from '../../../../../helpers/dotenv';
import { PerPage } from 'helpers/system-config';

const defaultColums = [
    'PhoneNumber',
    'duration',
    'hungupCause',
    'status',
    'data'
];

export class Report extends Component {

    constructor(props) {
        super(props);
        this.mAPI = new APIManager();
        this.moduleName = `IVR Report`;
        this.moduleUrl = `voice-cdr-report/list`;
        let selectedColumList = defaultColums;
        this.state = {
            isActive: false,
            listData: [],
            listField: [],
            configList: [],
            loading: false,
            showHide: false,
            modalType: modalType,
            total: 0,
            currentPage: 1,
            perPageCount: PerPage,
            search: '',
            MasterChecked: false,
            SingleChecked: false,
            SelectedList: [],
            ary: [],
            Filters: {},
            selectedFilter: {},
            assetsUrl: "",
            campaign: [],
            columnList: defaultColums,
            selectedColumList: selectedColumList,
            customerColumn: {},
            showColumn: false
        };
        this.bindThis();
    }
    bindThis() {
        this.onPaginationChange = this.onPaginationChange.bind(this);
        this.onPerPageChooser = this.onPerPageChooser.bind(this);
        this.getReportName = this.getReportName.bind(this);
        // this.getData = this.getData.bind(this);
        this.getSelectedColumnNames = this.getSelectedColumnNames.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openModal = this.openModal.bind(this);
        // this.downloadReport = this.downloadReport.bind(this);
        this.open = this.open.bind(this);
        this.handleModalShowColumn = this.handleModalShowColumn.bind(this);
        // this.getFilter = this.getFilter.bind(this);
        // this.onCustomColumnClick = this.onCustomColumnClick.bind(this);
    }
    componentDidMount() {
        // this.getList();
    }

    open() {
        if (this.state.isActive) {
            this.setState({ isActive: false });
        } else {
            this.setState({ isActive: true });
        }
    }

    openModal() {
        this.setState({ showHide: true });
    }

    closeModal() {
        this.setState({ showHide: false });
    }

    getReportName() {
        return 'default';
    }

    handleModalShowColumn() {
        this.setState({ showColumn: !this.state.showColumn });
    }

    getSelectedColumnNames() {
        return this.state.selectedColumList;
    }

    onMasterCheck(e) {
        let tempList = this.state.listData;
        // Check/ UnCheck All Items
        tempList.map(listData => (listData.selected = e.target.checked));
        //Update State
        this.setState({
            MasterChecked: e.target.checked,
            listData: tempList,
            SelectedList: this.state.listData.filter(e => e.selected)
        });
    }

    onItemCheck(e, item) {
        let tempList = this.state.listData;
        tempList.map(user => {
            if (user._id === item._id) {
                user.selected = e.target.checked;
            }
            return user;
        });
        //To Control Master Checkbox State
        const totalItems = this.state.listData.length;
        const totalCheckedItems = tempList.filter(e => e.selected).length;
        // Update State
        this.setState({
            MasterChecked: totalItems === totalCheckedItems && e.target.checked,
            listData: tempList,
            SelectedList: this.state.listData.filter(e => e.selected)
        });
    }

    onPaginationChange(page) {
        this.setState({ currentPage: page });
        this.getList(page, this.state.perPageCount, this.state.Filters);
    }

    onPerPageChooser(perPage) {
        this.setState({ currentPage: 1 });
        this.setState({ perPageCount: perPage });
        this.getList(1, perPage, this.state.Filters);
    }

    remove(array, key, value) {
        const index = array.findIndex(obj => obj[key] === value);
        return index >= 0
            ? [...array.slice(0, index), ...array.slice(index + 1)]
            : array;
    }

    renderContent() {
        const { brands, history, queryParams } = this.props;
        return (
            <InsightWrapper>
                <Filter
                    filterList={["renderFrom", "renderTo", "renderTimezones"]}
                    getSelectedColumnNames={this.getSelectedColumnNames}
                    getData={this.getData}
                    history={history}
                    brands={[]}
                    queryParams={[]}
                    selectedFilter={this.state.selectedFilter}
                    setFilter={this.setFilter}
                    updateFilter={this.updateFilter}
                    CampaignList={this.state.campaign}
                />
                {this.renderCharts()}
            </InsightWrapper>
        );
    }

    renderCharts() {
        return null;
    }

    render() {
        const { __ } = this.context;
        const breadcrumb = [
            { title: __('Reporting'), link: '/reporting' },
            { title: __('IVR Report'), link: '/reporting/ivr-report' }
        ];

        let _this = this;
        const mainContent = (
            <div style={{ "overflowX": "scroll", "margin": "10px" }} >
                <Table whiteSpace="nowrap" bordered hover>
                    <thead>
                        <tr>
                            {this.state.listField.map(column => {
                                return column.isDefault ? (<th>{column.lable}</th>) : "";
                            }
                            )}
                        </tr>
                    </thead>
                    <tbody id="Report">
                        {_this.state.listData.map(tData => {
                            return (
                                <tr >
                                    {
                                        _this.state.listField.map(column => {
                                            if (column.isDefault) {
                                                let result = tData[column.column];
                                                let isMediaType = column.dataType;
                                                if (typeof result != "string" && typeof result != "number") {
                                                    if (typeof result == "object") {
                                                        try {
                                                            result = JSON.stringify(result);
                                                        } catch (error) {

                                                        }
                                                    } else {
                                                        result = "-";
                                                    }
                                                }
                                                if (isMediaType === "media") {
                                                    return (
                                                        <td style={{ "overflow": "hidden", "textOverflow": "ellipsis" }} >
                                                            <FormGroup>
                                                                <FormControl
                                                                    componentClass="audioPlayer"
                                                                    src={`${this.state.assetsUrl}/${result}`}
                                                                    controls
                                                                    style={{ height: '25px', width: '100%' }}
                                                                />
                                                            </FormGroup>
                                                        </td>
                                                    )
                                                } else {
                                                    return (
                                                        <td style={{ "overflow": "hidden", "textOverflow": "ellipsis", "maxWidth": "186px" }} >
                                                            <Tip text={result} >
                                                                <span>{result}</span>
                                                            </Tip>
                                                        </td>
                                                    )
                                                }
                                                // return (
                                                //   <td style={{ "overflow": "hidden", "textOverflow": "ellipsis", "maxWidth": "186px" }} >
                                                //     <Tip text={result} >
                                                //       <span>{result}</span>
                                                //     </Tip>
                                                //   </td>
                                                // )
                                            } else {
                                                return "";
                                            }
                                        })
                                    }
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
                {/* </Row> */}
            </div>
        );

        const editColumns = (
            <Button btnStyle="simple" size="small">
                Edit columns
            </Button>
        );

        const actionBarRight = (
            <BarItems>
                <ModalTrigger
                    title="Choose which column you see"
                    trigger={editColumns}
                    showHide={this.state.showHide}
                    closeModal={this.closeModal}
                    openModal={this.openModal}
                    modalType={this.state.modalType}
                >
                    <ManageColumns
                        contentType="cdrReport"
                        config={this.state.selectedColumList}
                        save={this.onCustomColumnClick}
                        closeModal={this.closeModal}
                        fields={this.state.columnList}
                    />
                </ModalTrigger>

                <Button
                    btnStyle="filter"
                    size="small"
                    onClick={() => this.open()}
                >
                    <img src="/images/filter.png" style={{ width: '15px', marginRight: '5px' }} />Filters
                </Button>
                <Button
                    btnStyle="default"
                    size="small"
                    // onClick={this.downloadReport}
                    onClick={() =>
                        this.downloadReport(1, "", this.state.Filters)
                    }
                >
                    Download
                </Button>
            </BarItems>
        );


        return (
            <div>
                <DataWrapperClass>

                    {this.state.isActive && <WrapperData content={this.renderContent()} overflow={true} />}

                    <WrapperData
                        header={<Wrapper.Header breadcrumb={breadcrumb} />}
                        actionBar={
                            <Wrapper.ActionBar
                                left={
                                    <div>
                                        <ControlLabel>{`${this.moduleName} (${this.state.total || 0})`}</ControlLabel>

                                    </div>
                                }
                                right={actionBarRight}
                            />
                        }
                        footer={
                            <ReportPagination
                                count={this.state.total}
                                onPaginationChange={this.onPaginationChange}
                                onPerPageChooser={this.onPerPageChooser}
                                currentPage={this.state.currentPage}
                                perPage={this.state.perPageCount}
                            />
                        }
                        content={
                            <div>
                                <DataWithLoader
                                    data={mainContent}
                                    loading={this.state.loading}
                                    size={this.state.listData.length}
                                    count={this.state.listData.length}
                                    emptyText=""
                                    emptyImage="/images/empty/no_report.png"
                                />
                            </div>
                        }
                    />
                </DataWrapperClass>
            </div>
        )
    }
}

Report.contextTypes = {
    __: PropTypes.func
};

export default Report


// WEBPACK FOOTER //
// src/modules/screens/reporting/IVRReport/components/Report.js